export default __webpack_public_path__ + "static/media/calendar.9a51526d.svg";